module.exports = __webpack_public_path__ + "media/images/views/talent/benefit-run-6f55c218d23a8681075390c5788b3854.png";